module.exports = __webpack_public_path__ + "img/simon_zsuzsanna_reszketes_2_1.217a6561.jpg";